const normalizeBaseUrl = (url) => {
  const trimmed = String(url || "http://localhost:8080").trim().replace(/\/+$/, "");
  return `${trimmed}/`;
};

const baseUrl = normalizeBaseUrl(process.env.REACT_APP_BASE_URL);

const authToken = localStorage.getItem("user_id");

const config = {
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${authToken}`,
  },
};

// Function to get config with token from Redux store
export const getConfigWithToken = (token) => ({
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  },
});

export { baseUrl, config };
